import {
    GET_FEATURES,
    SET_REPORT_DETAILS,
    GET_TEMPLATES,
    SET_NEW_GROUP,
    GET_INSPECTIONS,
    REMOVE_TEMPLATE,
    SET_NEW_ITEM,
    // ARCHIEVE_TEMPLATE,
    EDIT_GROUP,
    REMOVE_GROUP,
    EDIT_ITEM,
    COPY_TEMPLATE,
    GET_ARCHIEVE_TEMPLATES
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

export const getTemplates = () => {
    return dispatch => {
        dispatch({ type: GET_TEMPLATES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/inspection_checklist_templates`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TEMPLATES.FAIL });
        }
    };
};

export const getArchieveTemplates = () => {
    return dispatch => {
        dispatch({ type: GET_ARCHIEVE_TEMPLATES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_ARCHIEVE_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/inspection_templates_archieve`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_ARCHIEVE_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_ARCHIEVE_TEMPLATES.FAIL });
        }
    };
};

export const getCopyTemplate = (ref,path) => {
    return dispatch => {
        dispatch({ type: COPY_TEMPLATE.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: COPY_TEMPLATE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/${path}/${id}/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: COPY_TEMPLATE.SUCCESS,
                                payload: snapshot.val()
                                
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TEMPLATES.FAIL });
        }
    };
};


export const templateCopy = (ref,data,createdBy, path) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    // callback(true);
                } 
                firebase
                    .database()
                    .ref(`/collections/${path}/${id}`)
                    .update(data)
                    .then(() => {
                        firebase
                            .database()
                            .ref(`/collections/${path}/${id}/profile/`)
                            .update({title : ref})
                            .then(() => {
                                firebase
                                    .database()
                                    .ref(`/collections/${path}/${id}/profile/created_by`)
                                    .update(createdBy)
                                dispatch({
                                    type: SET_REPORT_DETAILS.SUCCESS
                                })
                            })
                        dispatch({
                            type: SET_REPORT_DETAILS.SUCCESS
                        })
                    })
                    // callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        // callback(true);
    };
};


export const removeTemplate = (ref,path) => {
    return dispatch => {
        dispatch({ type: REMOVE_TEMPLATE.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_TEMPLATE.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/${path}`)
                    .child(`${id}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: REMOVE_TEMPLATE.FAIL });
        }
    };
};

export const getFeatures = () => {
    return dispatch => {
        dispatch({ type: GET_FEATURES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_FEATURES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/features")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_FEATURES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_FEATURES.FAIL });
        }
    };
};

export const setReportDetails = (details,createdBy) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = details.title.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    // callback(true);
                } 
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/profile`)
                    .update(details)
                    .then(() => {
                        firebase
                            .database()
                            .ref(`/collections/inspection_templates_archieve/${id}/profile/created_by`)
                            .update(createdBy)
                        dispatch({
                            type: SET_REPORT_DETAILS.SUCCESS
                        })
                    })
                    // callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        // callback(true);
    };
};

export const setDeleted = (details, callback) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = details.title.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    callback(true);
                } 
                firebase
                    .database()
                    .ref(`/collections/inspection_checklist_templates/${id}/profile`)
                    .update(details);
                    callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        callback(true);
    };
};

export const addGroup = (group, gname, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections/${group.section_id}/profile`)
                    .update(group);
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const editGroup = (group, uid, ref) => {
    return dispatch => {
        dispatch({ type: EDIT_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: EDIT_GROUP.FAIL });
                }
                
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections/${uid}/profile`)
                    .update(group);
            });
        } catch (e) {
            dispatch({ type: EDIT_GROUP.FAIL });
        }
    };
};

export const removeGroup = ( uid, ref) => {
    return dispatch => {
        dispatch({ type: REMOVE_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_GROUP.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections`)
                    .child(`${uid}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: REMOVE_GROUP.FAIL });
        }
    };
};

export const addItem =  (item,itemid, groupid, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_ITEM.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged( async user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_ITEM.FAIL });
                }
                    item["item_icon"] = await uploadImages(
                        item["item_icon"],
                        id,
                        itemid,
                        groupid
                    );
                    
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections/${groupid}/items/${itemid}`)
                    .update(item);
        })
    }
    catch (e) {
        dispatch({ type: SET_NEW_ITEM.FAIL });
    }
}
};

export const editItem = (item, gid, itemid, ref) => {
    
    return dispatch => {
        dispatch({ type: EDIT_ITEM.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: EDIT_ITEM.FAIL });
                }
                
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections/${gid}/items/${itemid}`)
                    .update(item);
            });
        } catch (e) {
            dispatch({ type: EDIT_ITEM.FAIL });
        }
    };
};

export const editItemIcon = (item, gid, itemid, ref) => {
    return dispatch => {
        dispatch({ type: EDIT_ITEM.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged( async user => {
                if (user === null) {
                    dispatch({ type: EDIT_ITEM.FAIL });
                }
                item["item_icon"] = await uploadImages(
                    item["item_icon"],
                    id,
                    itemid,
                    gid
                );
                firebase
                    .database()
                    .ref(`/collections/inspection_templates_archieve/${id}/sections/${gid}/items/${itemid}`)
                    .update(item);
            });
        } catch (e) {
            dispatch({ type: EDIT_ITEM.FAIL });
        }
    };
};

export const uploadImages = async (imgBlob,id,itemid,gid) => {
    if (imgBlob) {
        let imgUploadURL = firebase
            .storage()
            .ref(`/inspections/sections/${id}/${gid}/${itemid}/`)
            .put(imgBlob)
            .then(async snapshot => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return "";
                }
            })
            .catch(() => {
                return "";
            });
        return imgUploadURL;
    } else {
        return "";
    }
};

export const getInspections = (templateName, path) => {
    return dispatch => {
        dispatch({ type: GET_INSPECTIONS.REQUEST });
        let reference = templateName.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_INSPECTIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/${path}/${id}/sections/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_INSPECTIONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_INSPECTIONS.FAIL });
        }
    };
};